// extracted by mini-css-extract-plugin
module.exports = {"bold":"style__bold__Y6VfQ","button":"style__button__wjVld","sendInfo":"style__sendInfo__WPfvk","subNote":"style__subNote__Dabwg"};